import { render, staticRenderFns } from "./NotificationDisplay.vue?vue&type=template&id=33d617c8&scoped=true&"
import script from "./NotificationDisplay.vue?vue&type=script&lang=js&"
export * from "./NotificationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDisplay.vue?vue&type=style&index=0&id=33d617c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d617c8",
  null
  
)

export default component.exports